import React from 'react';

const MicrosoftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    {...props}
  >
    <path d="M0.5 0H20.5V20H0.5V0Z" fill="#F3F3F3" />
    <path
      d="M1.36914 0.869141H10.0648V9.56479H1.36914V0.869141Z"
      fill="#F35325"
    />
    <path
      d="M10.9355 0.869141H19.6312V9.56479H10.9355V0.869141Z"
      fill="#81BC06"
    />
    <path
      d="M1.36914 10.4346H10.0648V19.1302H1.36914V10.4346Z"
      fill="#05A6F0"
    />
    <path
      d="M10.9355 10.4346H19.6312V19.1302H10.9355V10.4346Z"
      fill="#FFBA08"
    />
  </svg>
);

export default MicrosoftIcon;
